import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5"
}
const _hoisted_2 = { class: "skeleton-header mb-10 mt-10" }
const _hoisted_3 = { class: "d-flex mb-10" }
const _hoisted_4 = {
  key: 1,
  class: "p-5"
}
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title w-100 m-0" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  style: {"background-color":"#53b0f8"},
  class: "px-2 py-3 rounded text-white"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "agregados", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "todos os modelos", -1)
const _hoisted_11 = { class: "mt-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-file-alt fs-1 me-2" }),
  /*#__PURE__*/_createElementVNode("span", null, "Detalhe")
], -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mt-5" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "mt-5" }
const _hoisted_17 = { class: "p-0" }
const _hoisted_18 = {
  class: "rounded p-3 mb-3 d-flex justify-content-between",
  style: {"list-style":"none","border":"rgb(232 237 241) solid 1px"}
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "table table-striped mb-5" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("h4", null, "Pacote")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("h4", null, "Código")
    ])
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "Básico", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "Intermediário", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, "Recomendado", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "Extra", -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "mt-5" }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "mt-10" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "d-flex col-12 col-md-6 align-items-center" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2 mb-0" }, "Veiculo:", -1)
const _hoisted_33 = { class: "mb-0" }
const _hoisted_34 = { class: "d-flex col-12 col-md-6 align-items-center" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Código Fábrica:", -1)
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = { class: "row mt-3" }
const _hoisted_38 = { class: "d-flex col-12 col-md-6 align-items-center" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2 mb-0" }, "Código:", -1)
const _hoisted_40 = { class: "mb-0" }
const _hoisted_41 = { class: "d-flex col-12 col-md-6 align-items-center" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Quantidade Peça ou Tempo MO:", -1)
const _hoisted_43 = { class: "mb-0" }
const _hoisted_44 = { class: "row mt-3" }
const _hoisted_45 = { class: "d-flex col-12 col-md-6 align-items-center" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2 mb-0" }, "Preço: ", -1)
const _hoisted_47 = { class: "mb-0" }
const _hoisted_48 = { class: "d-flex col-12 col-md-6 align-items-center" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2 mb-0" }, "Hora Mão Obra: ", -1)
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = { key: 3 }
const _hoisted_52 = { class: "mt-10" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "d-flex col-12 col-md-6 align-items-center" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2 mb-0" }, "Descrição:", -1)
const _hoisted_56 = { class: "mb-0" }
const _hoisted_57 = { class: "d-flex col-12 col-md-6 align-items-center" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Máximo de Parcelas Exibidas:", -1)
const _hoisted_59 = { class: "mb-0" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "d-flex col-12 col-md-6 align-items-center" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2 mb-0" }, "Parcelas Padrão Marcada:", -1)
const _hoisted_63 = { class: "mb-0" }
const _hoisted_64 = { class: "d-flex col-12 col-md-6 align-items-center" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2 mb-0" }, "Juros:", -1)
const _hoisted_66 = { class: "mb-0" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = {
  key: 0,
  class: "d-flex col-12 col-md-6 align-items-center"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2 mb-0" }, "Itens fora do Pacote tem Acréscimo de :", -1)
const _hoisted_70 = { class: "mb-0" }
const _hoisted_71 = { class: "mt-5" }
const _hoisted_72 = { class: "table table-responsive" }
const _hoisted_73 = {
  key: 0,
  rowhighlightclass: "ewTableHighlightRow",
  rowselectclass: "ewTableSelectRow",
  roweditclass: "ewTableEditRow",
  class: "table table-flush align-middle table-row-bordered table-row-solid gy-4 gx-4 gs-9"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "align-top text-muted" }, "Mídia"),
    /*#__PURE__*/_createElementVNode("th", { class: "align-top text-muted" }, "Codigo"),
    /*#__PURE__*/_createElementVNode("th", { class: "align-top text-muted" }, "Item"),
    /*#__PURE__*/_createElementVNode("th", { class: "align-top text-muted" }, "Preço")
  ])
], -1)
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("i", {
  style: {"color":"red"},
  class: "bi bi-collection-play-fill fs-2"
}, null, -1)
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Peça:", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "M.O:", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Cód. Alacarte:", -1)
const _hoisted_81 = { style: {"min-width":"200px"} }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Peça:", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Fixo MO:", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Hora MO:", -1)
const _hoisted_86 = { key: 1 }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Total Price:", -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Fixo MO:", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_91 = { style: {"cursor":"pointer"} }
const _hoisted_92 = {
  style: {"color":"#009ef7"},
  href: ""
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total")
], -1)
const _hoisted_94 = { key: 0 }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Peça:", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Fixo MO:", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Hora MO:", -1)
const _hoisted_98 = { key: 1 }
const _hoisted_99 = { key: 4 }
const _hoisted_100 = { class: "mt-5" }
const _hoisted_101 = { class: "row mb-3" }
const _hoisted_102 = { class: "col-6" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Código Peça:", -1)
const _hoisted_104 = { class: "col-6" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Código Mão de Obra:", -1)
const _hoisted_106 = { class: "row mb-3" }
const _hoisted_107 = { class: "col-6" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Preço Peça:", -1)
const _hoisted_109 = { class: "col-6" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Valor Mão de Obra:", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Tempo Mão de Obra:", -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-sort fs-1 me-2" }),
  /*#__PURE__*/_createElementVNode("span", null, "Ordenação")
], -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-edit fs-1 me-2" }),
  /*#__PURE__*/_createElementVNode("span", null, "Editar")
], -1)

import { ref, onMounted, reactive, watch } from "vue";
import useEmitter from "@/composables/Emmiter";
import {
  itemDisplay,
  updateOrder,
  familyDetailView,
  revisionDetailView,
  revisionItemDetailView,
  itemRevisionDetailView,
  packageRevisionDetailView,
  itemPackageDetailView,
} from "@/services/CardapioService";
import {
  GroupDisplay,
  FamilyDetailView,
  RevisionDetailView,
  RevisionItemDetailView,
  PackageRevisionDetailView,
  ItemDetailRevision,
  ItemPackageDetailView,
  DadosExtraPackageRevisionDetailView,
} from "@/models/CardapioModel";
import FormFamily from "@/views/cardapio/tree/components/EditForm/FormFamily.vue";
import FormPackage from "@/views/cardapio/tree/components/EditForm/FormPackage.vue";
import FormPackageItem from "@/views/cardapio/tree/components/EditForm/FormPackageItem.vue";
import FormCar from "@/views/cardapio/tree/components/EditForm/FormCar.vue";
import FormRevision from "@/views/cardapio/tree/components/EditForm/FormRevision.vue";
import FormRevisionItem from "@/views/cardapio/tree/components/EditForm/FormRevisionItem.vue";
import { useRouter } from "vue-router";
import { filterCardapio } from "@/pinia/cardapio/filter/useFilterCardapio";
import Order from "@/views/cardapio/tree/components/order/Order.vue";
import DadosExtra from "./DadosExtra.vue";
import { Modal } from "bootstrap";


export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  setup(__props) {

const niveisTree = {
  familia: 1,
  modeloVeiculo: 2,
  revisao: 3,
  itemRevisao: 4,
  pacote: 5,
  itemPacote: 6  
}
const emitter = useEmitter();
const router = useRouter();
const dadosExtraSelect = ref<DadosExtraPackageRevisionDetailView | null>(null);
const storeFilter = filterCardapio();
const concessionariaSelected = ref(localStorage.getItem("filtroConcessionaria") ? Number(localStorage.getItem("filtroConcessionaria")) : 0);
const infoItem = ref<GroupDisplay>();
const level = ref(0);
const activeName = ref("detalhe");
const items = ref([""]);
const dataFamilyDetailView = ref<FamilyDetailView>();
const itemSelect = ref();
const dataViewRevision = ref<RevisionDetailView>();
const dataViewItemRevision = ref<RevisionItemDetailView>();
const dataItemRevision = ref<ItemDetailRevision>();
const dataPackageRevisionDetailView = ref<PackageRevisionDetailView>();
const dataItemPackageDetailView = ref<ItemPackageDetailView>();
const packagePosition = ref(true);
const modalDadosExtra = ref();
const titleEdit = ref("Família/Grupo de exibição");
const loading = reactive({
  updateButton: false,
  tabs: false,
});

const handleClick = (tab, event) => {
  // console.log(tab, event);
};

onMounted(() => {
  activeName.value = "detalhe"
  getDetailItem()
  concessionariaSelected.value = Number(localStorage.getItem("filtroConcessionaria"));
  const refModal = document.getElementById("modalDadosExtra");
  if (refModal) {
    modalDadosExtra.value = new Modal(refModal);
  }
});

watch(
  () => storeFilter.getCodConcessionaria,
  (newValue) => {
    concessionariaSelected.value = newValue;
    getDetailItem();
  }
);

// emitter.on("filter-cardapio", async ({ codConcessionaria }) => {
//   concessionariaSelected.value = codConcessionaria;
//   getDetailItem();
// });

const handleModalDadosExtra = (
  dadosExtra: DadosExtraPackageRevisionDetailView | null
) => {
  modalDadosExtra.value?.show();
  dadosExtraSelect.value = dadosExtra;
};

emitter.on("update-family", () => {
  activeName.value = "detalhe";
  level.value = 0;
});

emitter.on("select-item", async (item) => {
  try {
    scrollToDiv();

    loading.tabs = true;
    itemSelect.value = item;
    level.value = item.level ?? 0;

    //carros
    if (level.value == niveisTree.familia && item.name && concessionariaSelected.value) {
      const payload = {
        codConcessionaria: Number(concessionariaSelected.value),
        grupoExibicao: item.name,
      };

      activeName.value = "ordenação";
      const response = await familyDetailView(payload);
      items.value = response.car.map(({ carro }) => carro);
      dataFamilyDetailView.value = response;

      titleEdit.value = `
      <div class="d-flex justify-content-between">
        <div>${response.family}</div> 
        <div>${response.detail.carros} carros criados - Mo Valor: R$ ${response.detail.horaMaoObra}
        </div>
     </div>`;
    }

    //revisoes

    if (level.value == niveisTree.modeloVeiculo && item.family && item.name) {
      const payload = {
        codConcessionaria: Number(concessionariaSelected.value),
        grupoExibicao: item.family,
        car: item.name,
      };

      activeName.value = "ordenação";
      const response = await revisionDetailView(payload);
      items.value = response.order.map(({ revisao }) => revisao);
      dataViewRevision.value = response;
      titleEdit.value = response.car;
      titleEdit.value = `
      <div class="d-flex justify-content-between">
        <div>${response.family}</div> 
        <div>${response.revisionQtd} Revisões criados
        </div>
     </div>`;
    }

    if (
      level.value == niveisTree.revisao &&
      item.vehicles &&
      item.family &&
      item.revisao
    ) {
      const payload = {
        codConcessionaria: Number(concessionariaSelected.value),
        grupoExibicao: item.vehicles,
        car: item.family,
        revison: item.revisao,
        factoryCode: item.codigoFabrica,
      };

      const response = await revisionItemDetailView(payload);
      items.value = response.dataTable.map(({ peca }) => peca);
      dataViewItemRevision.value = response;
      titleEdit.value = `${response.car} - ${response.revison}`;
      activeName.value = "detalhe";
    }

    if (
      level.value == niveisTree.itemRevisao &&
      item.grupoExibicao &&
      item.carro &&
      item.revisao &&
      item.peca
    ) {
      const payload = {
        codConcessionaria: Number(concessionariaSelected.value),
        grupoExibicao: item.grupoExibicao,
        car: item.carro,
        revison: item.revisao,
        factoryCode: item.codigoFabrica,
        part: item.peca,
      };

      const response = await itemRevisionDetailView(payload);
      dataItemRevision.value = response;
      items.value = [];
      titleEdit.value = `${response.peca} - ${response.revisao}`;
      activeName.value = "detalhe";
    }

    if (level.value == niveisTree.pacote) {
      const payload = {
        codConcessionaria: Number(concessionariaSelected.value),
        grupoExibicao: item.grupoExibicao,
        codPacote: item.codPackage,
      };

      packagePosition.value = item.existChildren;

      const response = await packageRevisionDetailView(payload);
      dataPackageRevisionDetailView.value = response;
      titleEdit.value = `
      <div class="d-flex justify-content-between">
        <div>${response.namePackage} - Código ${response.codPacote}</div> 
        <div>${response?.dataTable ? response?.dataTable.length : 0} item existentes
        </div>
     </div>`;

      items.value = response.dataTable.map(({ servico }) => servico);
      activeName.value = "detalhe";
    }

    if (level.value == niveisTree.itemPacote && item.codAgregados) {
      const payload = {
        codConcessionaria: Number(concessionariaSelected.value),
        codAgregado: item.codAgregados,
      };

      const response = await itemPackageDetailView(payload);
      dataItemPackageDetailView.value = response;
      titleEdit.value = `${response.servico} - ${response.nome} ${response.codPacote}`;
      items.value = [];
      activeName.value = "detalhe";
    }
  } catch (error) {
    console.log(error);
    loading.tabs = false;
  } finally {
    loading.tabs = false;
  }
});

const getDetailItem = async () => {
  loading.tabs = true;
  const response = await itemDisplay(concessionariaSelected.value);
  loading.tabs = false;
  infoItem.value = response;
  items.value = response.vehicle.map(({ grupoExibicao }) => grupoExibicao);
};

const goToAddItem = (codPacote: number | undefined, namePacote: string | undefined) => {
  if (codPacote && namePacote) {
    emitter.emit("salve-history-tree", {});
    router.push({
      name: "adicionar-item",
      params: {
        codConcessionaria: btoa(concessionariaSelected.value?.toString()),
        nivel: btoa(level.value?.toString()),
        codPacote: btoa(codPacote.toString()),
      },
      query: {
        nomePacote: namePacote,
      },
    });
  }
};

const scrollToDiv = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const getRandomWidth = () => {
  const minWidth = 1;
  const maxWidth = 100;
  const width = Math.floor(Math.random() * (maxWidth - minWidth + 1)) + minWidth;
  return `${width}%`;
};

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    (loading.tabs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_skeleton, { animated: "" }, {
              template: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"100%","height":"35px"}
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_skeleton, { animated: "" }, {
              template: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    class: "ms-10",
                    style: {"width":"120px","height":"50px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    class: "ms-3",
                    style: {"width":"120px","height":"50px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    class: "ms-3",
                    style: {"width":"120px","height":"50px"}
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_skeleton, {
              animated: "",
              count: "10"
            }, {
              template: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                  return _createElementVNode("div", {
                    class: "skeleton-item",
                    key: i
                  }, [
                    _createVNode(_component_el_skeleton_item, {
                      variant: "text",
                      class: "mb-3",
                      style: _normalizeStyle({
                  width: getRandomWidth(),
                  height: '20px',
                })
                    }, null, 8, ["style"])
                  ])
                }), 64))
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, [
              _createElementVNode("label", {
                innerHTML: titleEdit.value,
                class: "card-label fw-bolder w-100"
              }, null, 8, _hoisted_7)
            ])
          ]),
          (level.value == niveisTree.itemPacote || (level.value == niveisTree.pacote && dataPackageRevisionDetailView.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createTextVNode(" Qualquer alteração realizada em "),
                _hoisted_9,
                _createTextVNode(" irá impactar em "),
                _hoisted_10,
                _createTextVNode(" vinculados ao "),
                _createElementVNode("strong", null, _toDisplayString(dataPackageRevisionDetailView.value?.namePackage) + " - Código " + _toDisplayString(dataPackageRevisionDetailView.value?.codPacote), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_tabs, {
              modelValue: activeName.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
              type: "card",
              class: "demo-tabs P-0",
              onTabClick: handleClick,
              id: "edit-tab"
            }, {
              default: _withCtx(() => [
                (level.value != 1 && level.value != 2)
                  ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: 0,
                      name: "detalhe"
                    }, {
                      label: _withCtx(() => [
                        _hoisted_12
                      ]),
                      default: _withCtx(() => [
                        (level.value == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                (infoItem.value)
                                  ? (_openBlock(), _createElementBlock("h4", _hoisted_15, _toDisplayString(infoItem.value.qtdVehicle) + " Família/Grupo de exibição criados ", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("ul", _hoisted_17, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoItem.value?.vehicle, (veiculo) => {
                                      return (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                        _createElementVNode("span", null, _toDisplayString(veiculo.grupoExibicao), 1),
                                        _createElementVNode("span", null, _toDisplayString(veiculo.qtd) + " carros existentes ", 1)
                                      ]))
                                    }), 256))
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (level.value == niveisTree.revisao)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("table", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_22,
                                    _createElementVNode("td", null, _toDisplayString(dataViewItemRevision.value?.codigoBasico
                          ? dataViewItemRevision.value?.codigoBasico
                          : "Sem cód."), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_23,
                                    _createElementVNode("td", null, _toDisplayString(dataViewItemRevision.value?.codigoIntermediario
                          ? dataViewItemRevision.value?.codigoIntermediario
                          : "Sem cód."), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_24,
                                    _createElementVNode("td", null, _toDisplayString(dataViewItemRevision.value?.codigoRecomendado
                          ? dataViewItemRevision.value?.codigoRecomendado
                          : "Sem cód."), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_25,
                                    _createElementVNode("td", null, _toDisplayString(dataViewItemRevision.value?.codigoExtra
                          ? dataViewItemRevision.value?.codigoExtra
                          : "Sem cód."), 1)
                                  ])
                                ])
                              ]),
                              (
                  dataViewItemRevision.value?.dataTable &&
                  dataViewItemRevision.value?.dataTable.length > 0
                )
                                ? (_openBlock(), _createBlock(_component_el_table, {
                                    key: 0,
                                    data: dataViewItemRevision.value?.dataTable,
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_table_column, { label: "Código" }, {
                                        default: _withCtx((scope) => [
                                          (scope.row.codigoPeca)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(scope.row.codigoPeca), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "peca",
                                        label: "Item"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "precoPeca",
                                        label: "Preço"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["data"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("h5", _hoisted_27, "Total: " + _toDisplayString(dataViewItemRevision.value?.totalSumPrice), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (level.value == niveisTree.itemRevisao)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _hoisted_32,
                                    _createElementVNode("p", _hoisted_33, _toDisplayString(dataItemRevision.value?.carro), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _hoisted_35,
                                    _createElementVNode("p", _hoisted_36, _toDisplayString(dataItemRevision.value?.codigoFabrica), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", _hoisted_38, [
                                    _hoisted_39,
                                    _createElementVNode("p", _hoisted_40, _toDisplayString(dataItemRevision.value?.codigoPeca), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_41, [
                                    _hoisted_42,
                                    _createElementVNode("p", _hoisted_43, _toDisplayString(dataItemRevision.value?.qtdPeca), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _hoisted_46,
                                    _createElementVNode("p", _hoisted_47, _toDisplayString(dataItemRevision.value?.precoPeca), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    _hoisted_49,
                                    _createElementVNode("p", _hoisted_50, _toDisplayString(dataItemRevision.value?.horaMaoObra), 1)
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (level.value == niveisTree.pacote)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _hoisted_55,
                                    _createElementVNode("p", _hoisted_56, _toDisplayString(dataPackageRevisionDetailView.value?.descricao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_57, [
                                    _hoisted_58,
                                    _createElementVNode("p", _hoisted_59, _toDisplayString(dataPackageRevisionDetailView.value?.parcela), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("div", _hoisted_61, [
                                    _hoisted_62,
                                    _createElementVNode("p", _hoisted_63, _toDisplayString(dataPackageRevisionDetailView.value?.parcelaPadrao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_64, [
                                    _hoisted_65,
                                    _createElementVNode("p", _hoisted_66, _toDisplayString(dataPackageRevisionDetailView.value?.descricaoJuros), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_67, [
                                  (
                      dataPackageRevisionDetailView.value?.acrescimoAlacarte != '0' &&
                      Number(dataPackageRevisionDetailView.value?.acrescimoAlacarte) > 0
                    )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                        _hoisted_69,
                                        _createElementVNode("p", _hoisted_70, _toDisplayString(dataPackageRevisionDetailView.value?.acrescimoAlacarte), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _createElementVNode("div", _hoisted_72, [
                                  (
                      dataPackageRevisionDetailView.value?.dataTable &&
                      dataPackageRevisionDetailView.value?.dataTable.length > 0
                    )
                                    ? (_openBlock(), _createElementBlock("table", _hoisted_73, [
                                        _hoisted_74,
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataPackageRevisionDetailView.value?.dataTable, (item, i) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                              _createElementVNode("td", null, [
                                                (item.dadosExtra)
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      onClick: ($event: any) => (handleModalDadosExtra(item.dadosExtra)),
                                                      style: {"cursor":"pointer"}
                                                    }, _hoisted_77, 8, _hoisted_75))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_78,
                                                  _createTextVNode(_toDisplayString(item?.codigoPeca), 1)
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _hoisted_79,
                                                  _createTextVNode(_toDisplayString(item?.codigoMaoObra), 1)
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _hoisted_80,
                                                  _createTextVNode(_toDisplayString(item?.codigoMaoObraAlacarte), 1)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, _toDisplayString(item?.servico), 1),
                                              _createElementVNode("td", _hoisted_81, [
                                                (packagePosition.value)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                      _createElementVNode("div", null, [
                                                        _hoisted_83,
                                                        _createTextVNode(_toDisplayString(item?.precoPeca), 1)
                                                      ]),
                                                      _createElementVNode("div", null, [
                                                        _hoisted_84,
                                                        _createTextVNode(_toDisplayString(item?.valorMaoObra), 1)
                                                      ]),
                                                      _createElementVNode("div", null, [
                                                        _hoisted_85,
                                                        _createTextVNode(_toDisplayString(item?.tempoMaoObra), 1)
                                                      ])
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                                      _createVNode(_component_el_tooltip, {
                                                        class: "box-item",
                                                        effect: "dark",
                                                        placement: "top-start"
                                                      }, {
                                                        content: _withCtx(() => [
                                                          _createElementVNode("div", null, [
                                                            _hoisted_87,
                                                            _createElementVNode("span", null, _toDisplayString(item?.totalPrice), 1),
                                                            _hoisted_88,
                                                            _hoisted_89,
                                                            _createElementVNode("span", null, _toDisplayString(item?.tempoMaoObra), 1),
                                                            _hoisted_90
                                                          ])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", _hoisted_91, [
                                                            _createElementVNode("a", _hoisted_92, _toDisplayString(item?.totalPrice), 1)
                                                          ])
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]))
                                              ])
                                            ]))
                                          }), 128)),
                                          _createElementVNode("tr", null, [
                                            _hoisted_93,
                                            (packagePosition.value)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_94, [
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("div", null, [
                                                      _hoisted_95,
                                                      _createTextVNode(" " + _toDisplayString(dataPackageRevisionDetailView.value?.totalPeca), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _hoisted_96,
                                                      _createTextVNode(_toDisplayString(dataPackageRevisionDetailView.value?.totalValorMaoObra), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _hoisted_97,
                                                      _createTextVNode(_toDisplayString(dataPackageRevisionDetailView.value?.totalTempoMaoObra), 1)
                                                    ])
                                                  ])
                                                ]))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_98, _toDisplayString(dataPackageRevisionDetailView.value?.totalPriceValue), 1))
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (level.value == niveisTree.itemPacote)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                              _createElementVNode("div", _hoisted_100, [
                                _createElementVNode("div", _hoisted_101, [
                                  _createElementVNode("div", _hoisted_102, [
                                    _hoisted_103,
                                    _createTextVNode(" " + _toDisplayString(dataItemPackageDetailView.value?.codigoPeca), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_104, [
                                    _hoisted_105,
                                    _createTextVNode(_toDisplayString(dataItemPackageDetailView.value?.codigoMaoObra), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_106, [
                                  _createElementVNode("div", _hoisted_107, [
                                    _hoisted_108,
                                    _createTextVNode(_toDisplayString(dataItemPackageDetailView.value?.precoPeca), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_109, [
                                    _hoisted_110,
                                    _createTextVNode(_toDisplayString(dataItemPackageDetailView.value?.valorMaoObra), 1)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_111,
                                  _createTextVNode(_toDisplayString(dataItemPackageDetailView.value?.tempoMaoObra), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (level.value != 4 && level.value != 6)
                  ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: 1,
                      name: "ordenação"
                    }, {
                      label: _withCtx(() => [
                        _hoisted_112
                      ]),
                      default: _withCtx(() => [
                        _createVNode(Order, {
                          items: items.value,
                          "item-select": itemSelect.value
                        }, null, 8, ["items", "item-select"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (level.value != 0)
                  ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: 2,
                      name: "editar"
                    }, {
                      label: _withCtx(() => [
                        _hoisted_113
                      ]),
                      default: _withCtx(() => [
                        (activeName.value === 'editar' && level.value == niveisTree.familia && dataFamilyDetailView.value)
                          ? (_openBlock(), _createBlock(FormFamily, {
                              key: 0,
                              updateFamily: dataFamilyDetailView.value
                            }, null, 8, ["updateFamily"]))
                          : _createCommentVNode("", true),
                        (
                activeName.value === 'editar' && level.value == niveisTree.pacote && dataPackageRevisionDetailView.value
              )
                          ? (_openBlock(), _createBlock(FormPackage, {
                              key: 1,
                              updatePackage: dataPackageRevisionDetailView.value
                            }, null, 8, ["updatePackage"]))
                          : _createCommentVNode("", true),
                        (activeName.value === 'editar' && level.value == niveisTree.itemPacote && dataItemPackageDetailView.value)
                          ? (_openBlock(), _createBlock(FormPackageItem, {
                              key: 2,
                              updatePackageItem: dataItemPackageDetailView.value
                            }, null, 8, ["updatePackageItem"]))
                          : _createCommentVNode("", true),
                        (activeName.value === 'editar' && level.value == niveisTree.modeloVeiculo && dataViewRevision.value)
                          ? (_openBlock(), _createBlock(FormCar, {
                              key: 3,
                              updateCar: dataViewRevision.value
                            }, null, 8, ["updateCar"]))
                          : _createCommentVNode("", true),
                        (activeName.value === 'editar' && level.value == niveisTree.revisao && dataViewItemRevision.value)
                          ? (_openBlock(), _createBlock(FormRevision, {
                              key: 4,
                              updateRevision: dataViewItemRevision.value
                            }, null, 8, ["updateRevision"]))
                          : _createCommentVNode("", true),
                        (activeName.value === 'editar' && level.value == niveisTree.itemRevisao && dataItemRevision.value)
                          ? (_openBlock(), _createBlock(FormRevisionItem, {
                              key: 5,
                              updateRevisionItem: dataItemRevision.value
                            }, null, 8, ["updateRevisionItem"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])),
    _createVNode(DadosExtra, { "dados-extra": dadosExtraSelect.value }, null, 8, ["dados-extra"])
  ]))
}
}

})